import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from './config';
import { defaultNS, namespaces, resources } from './resources';

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        ns: namespaces,
        defaultNS,
        supportedLngs: SUPPORTED_LANGUAGES,
        fallbackLng: DEFAULT_LANGUAGE,
        // "en-US" (navigateur) est accepté et ramené à "en".
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        // Traductions embarquées dans le bundle : initialisation synchrone, pas de texte vide
        // ni de clé affichée au premier rendu.
        initAsync: false,
        interpolation: {
            // React échappe déjà les valeurs (protection XSS).
            escapeValue: false,
        },
        detection: {
            // 1. langue de l'URL (/fr/..., /en/...) : source de vérité, indexable ;
            // 2. dernier choix de l'utilisateur ;
            // 3. langue du navigateur ; à défaut, fallbackLng (fr).
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            lookupLocalStorage: LANGUAGE_STORAGE_KEY,
            caches: ['localStorage'],
        },
    });

/** Attribut <html lang> : lecteurs d'écran, correcteur orthographique, moteurs de recherche. */
const syncDocumentLanguage = () => {
    document.documentElement.lang = i18n.resolvedLanguage ?? DEFAULT_LANGUAGE;
};

syncDocumentLanguage();
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
